import { ASSESSMENT_TYPE } from '../../FrontCore/src/constants/taskManager'

export const OK_FIRST_PART_TEMPLATE = 'ok-first-part'
export const OK_FIRST_PART_CATEGORIES = 'ok-first-part-categories'
export const OK_FIRST_PART_LAUNCH_REASONS = 'ok-first-part-launch-reasons'
export const OK_FIRST_PART_SOURCE = 'ok-first-part'
export const OK_FIRST_PART_TABLE_NAME = 'OK_FIRST_PART_LIST'
export const OK_FIRST_PART_ASSESSMENTS_TABLE_NAME = 'OK_FIRST_PART_ASSESSMENTS_LIST'
export const OK_FIRST_PART_BY_CHECKPOINT_TABLE_NAME = 'OK_FIRST_PART_BY_CHECKPOINT_LIST'
export const OK_FIRST_PART_CHECKPOINT_VERSIONS_TABLE_NAME = 'OK_FIRST_PART_CHECKPOINT_VERSIONS_LIST'
export const OK_FIRST_PART_BY_CHECKPOINT_TREND_CHART_KEY = 'ok_first_part_by_checkpoint_trend'
export const OK_FIRST_PART_FINISHED_BY_STATUS_CHART_KEY = 'ok_first_part_finished_by_status'

export const NAME_MAX_LENGTH = 300
export const DESCRIPTION_MAX_LENGTH = 900
export const REACTION_RULE_MAX_LENGTH = 900
export const IDENTIFICATION_MAX_LENGTH = 60

export const SCHEDULE_NOT_FINISHED = -1
export const SCHEDULE_OK = 0
export const SCHEDULE_NOK = 1
export const SCHEDULE_CONDITIONAL_OK = 2

export const SCHEDULE_STATUS = {
  [SCHEDULE_NOT_FINISHED]: 'ok_first_part.messages.not_finished',
  [SCHEDULE_NOK]: 'common.messages.nok_message',
  [SCHEDULE_OK]: 'common.messages.ok',
  [SCHEDULE_CONDITIONAL_OK]: 'ok_first_part.messages.conditional_ok',
}

export const ADDITIONAL_INFO_CATEGORY_TOKEN = 'common.messages.additional_info'


export { ASSESSMENT_TYPE }

export const VERSION_STATUS = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT',
  OLD_READ_ONLY: 'OLD_READ_ONLY',
  DISABLED: 'DISABLED',
}
